/**
 * Vendor application links must open in the browser, not the iOS app.
 * The link we send is https://app.pacarion.com/?vendorInvite=<token>.
 * /vendor-invite and /vendor-invite/* are excluded as well.
 * Homeowner invites (?homeowner_code= on /login) are not these links.
 */

function isVendorInviteUrl(raw) {
  let url;
  try {
    url = new URL(String(raw || ''), 'https://app.pacarion.com');
  } catch (error) {
    return false;
  }
  const host = url.hostname.replace(/^www\./, '').toLowerCase();
  if (host !== 'app.pacarion.com' && host !== 'localhost') return false;
  const path = url.pathname.replace(/\/+$/, '') || '/';
  if (path === '/vendor-invite' || path.startsWith('/vendor-invite/')) return true;
  return url.searchParams.has('vendorInvite');
}

/** A link is open only while its invite row is still unused and unexpired. */
function vendorInviteOpen(invite, now) {
  if (!invite || invite.status !== 'invited') return false;
  const expires = new Date(invite.expires_at).getTime();
  const at = now instanceof Date ? now.getTime() : Number(now);
  const moment = Number.isFinite(at) ? at : Date.now();
  return Number.isFinite(expires) && expires >= moment;
}

module.exports = { isVendorInviteUrl, vendorInviteOpen };
